import React from 'react';
import { HELP_MODAL_LINKS } from '../../../constants/common/HelpModalLinks';

/**
 * HelpModal
 */
class HelpModal extends React.Component {

  constructor(props) {
    super(props);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  handleCloseClick() {
    $('#help_modal').hide();
  }

  render() {
    const linkInfo = HELP_MODAL_LINKS;
    linkInfo[0].links[0].url = this.props.userGuideUrl;

    const Nodes = (
      linkInfo.map((linkInfo, parentIndex) => {
        return (
          <div key={parentIndex} className="help_modal_content" id="help_modal_content">
            {linkInfo.links.map((link, index) => {
              return (
                <div key={index} className="help_modal_item" id="help_modal_item">
                  <a href={link.url} className="tab-title" target="_blank" rel="noopener noreferrer">
                    {link.name}
                  </a>
                </div>
              );
            })}
          </div>
        );
      })
    );

    return (
      <div id="help_modal" className="help_modal" onClick={e => this.handleCloseClick(e)}>
        <div className="help_modal_bg" />
        <div id="help_modal_btn_close" className="help_modal_btn_close_area">
          {Nodes}
        </div>
      </div>
    );
  }
}

export default HelpModal;
